import styled from 'styled-components';

interface ColorProps {
	color: string;
}

const Option = styled('div')`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const OptionLabel = styled('span')`
	margin-right: 10px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

const OptionColorsList = styled('ul')`
	display: flex;
	margin: 0;
	padding: 0;
	list-style-type: none;
`;

const Color = styled('li')`
	width: 18px;
	height: 18px;
	border-radius: 50%;
	background-color: ${({ color }: ColorProps) => color};

	& + & {
		margin-left: 6px;
	}
`;

export {
	Option,
	OptionLabel,
	OptionColorsList,
	Color,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ThemesPanel/SelectTheme/styles.ts